import { createStore } from 'vuex';
import events from './events';
import eventTypes from './eventTypes';
import links from './links';
import solutions from './solutions';
import fleetSizes from './fleetSizes';
import home from './home';
import user from './user';

export default createStore({
  modules: {
    events,
    eventTypes,
    links,
    solutions,
    fleetSizes,
    home,
    user,
  },
  actions: {
    async initialize({ dispatch }) {
      dispatch('events/loadEvents');
      dispatch('eventTypes/loadEventTypes');
      dispatch('solutions/loadSolutions');
      dispatch('fleetSizes/loadFleetSizes');
    },
  },
});
